
import { CommodityAndUnitsRec } from "../ah.mb.commodity-and-units-rec";

export interface INodePathAndName {
    modelId: string;
    nodePathAndName: string;
    //    definition: IDashboardPublishDefinition;
}

export interface ISetNodeDataValueCommandPayload extends INodePathAndName {
    variableName: string;
    value: any;

}


    /**
     * INodeObject
     */
    export interface INodeObject {
        pathAndName: string;
        nodeType: string;
        path: string;
        name: string;
        isFolder: boolean;
        fqmId: string;
        //isShadow: () => boolean;
    }


    export interface ILinkObject {
        commodity: string;
        units: string;

        sourcePathAndName: string;
        destPathAndName: string;

        //properties: string; //Array<AH.MB.ModelUtils.LinkProperty>;
    }

    /**
     * Used for linking nodes across sectors
     */
    export interface ILinkingNode extends INodeObject {
        //inputLinks: ILinkObject[];
        outputLinks: ILinkObject[];
        commodities: CommodityAndUnitsRec[];        
    }

    /**
     * Concrete node object (used by model tree)
     */
    export class NodeObject implements INodeObject {

        pathAndName: string;
        nodeType: string;
        path: string;
        name: string;
        isFolder: boolean;
        fqmId: string;

        /**
         * Indicates if shadow name
         */
        static isShadowNodeName(name: string): boolean {
            return name.charAt(0) === "[";
        };

        /**
         * Path extractor
         * @param pathAndName
         */
        static extractPath(pathAndName: string): string {

            if (pathAndName) {
                // result is [Sector] NodeName
                const delim = pathAndName.lastIndexOf("\\");
                const sector = pathAndName.substring(0, delim);
                return sector;
            }
            return "";
        }

        /**
         * Name extractor
         */
        static extractName(pathAndName: string): string {

            const delim = pathAndName.lastIndexOf("\\");
            const name = pathAndName.substring(delim + 1);
            return name;
        }

        /**
         * Builds a renamed node path and name
         * @param nodePathAndName
         * @param newName
         */
        static buildRenamedNodePathAndName(nodePathAndName: string, newName: string): string {
            const delim = nodePathAndName.lastIndexOf("\\");
            const sector = nodePathAndName.substring(0, delim + 1);
            return sector + newName;
        }

        /**
         * Combines node path and name
        */
        static combinePathAndName (path: string, name: string): string  {
            return path + "\\" + name;
        }

        /**
         * Indicates if this is a shadow node
         */
        isShadow = (): boolean => NodeObject.isShadowNodeName(this.pathAndName);

        /**
         * Ctor
         * @param pathAndName
         * @param nodeType
         */
        constructor(pathAndName: string, nodeType: string, isFolder: boolean, fqmId: string) {

            this.pathAndName = pathAndName;
            this.nodeType = nodeType;

            if (pathAndName) {
                this.path = NodeObject.extractPath(pathAndName);
                this.name = NodeObject.extractName(pathAndName);
            };

            this.isFolder = isFolder;
            this.fqmId = fqmId;
        }

        static isScenarioModelId(modelId: string): boolean {
            return modelId.indexOf(":") > 0;
        }

        static extractPaths(nodePathAndName: string): string[] {
            return nodePathAndName.split("\\")
        };


    }

    export class LinkingNode extends NodeObject implements ILinkingNode {
        outputLinks: ILinkObject[];
        commodities: CommodityAndUnitsRec[];

        constructor() {
            super("", "", false, "");
            this.outputLinks = [];
            this.commodities = [];
        }
    }


// WEBPACK FOOTER //
// ./ClientApp/scripts/common/ah.mb.common.node-object.ts